<template>
  <div class="single-product-page">
    <div class="card">
      <h1>{{campaign.title}}</h1>
      <p>{{campaign.description}}</p>
    </div>
    <div v-if="campaign.offers.length > 0" class="extra-products">
      <p class="sub-title">Maak een keuze</p>
      <div class="product-holder">
        <div class="product"
            v-for="offer in campaign.offers"
            @click="select_offer(offer)"
            :key="offer.id">
          <div class="image-container"
           :style="`background-image: url(${axios.defaults.baseURL}${offer.image})`">
          </div>
          <div class="information">
            <h3>{{offer.title}}</h3>
            <p>{{offer.description}}</p>
            <p class="price">
              {{ offer_price(offer) }}
            </p>
          </div>
          <div class="c-checkmark">
            <label class="container">
              <span v-if="offer.selected" class="checkmark">✓</span>
              <span v-else class="checkbox"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <bottom-button state="payment" :amount="amount" @clicked="submit"/>
  </div>
</template>

<script>
import BottomButton from '@/components/Bottom-Button.vue';

export default {
  name: 'SingleProduct',
  components: {
    BottomButton,
  },
  computed: {
    campaign() {
      return this.$store.getters['application/getCampaign'];
    },
    order() {
      return this.$store.getters['application/getOrder'];
    },
    amount() {
      return this.$store.getters['application/getOrderPrice'];
    },
  },
  mounted() {
    this.select_offer(this.campaign.offers[0]);
  },
  methods: {
    submit() {
      if (!this.campaign.requires_address) {
        this.$store.dispatch('application/postOrder', true);
      } else {
        this.$router.push({ name: 'details' });
      }
    },
    select_offer(offer) {
      // Deselect all offers
      this.$store.dispatch('application/resetOffers');
      this.campaign.offers.forEach((selectedOffer) => {
        selectedOffer.selected = false; // eslint-disable-line
      });

      // Select the current offer
      this.$store.dispatch('application/selectOffer', offer);
      offer.selected = true; // eslint-disable-line

      this.$forceUpdate();
    },
    offer_price(offer) {
      return (offer.price_incl_vat / 100).toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'EUR',
      });
    },
  },
};
</script>

<style lang="scss">
  @import '@/assets/css/colors.scss';

  .single-product-page {
    > .card {
      text-align: left;
      min-height: 0;
    }
    table {
      text-align: left;
      th {
        padding-right: 10px;
      }
    }
    .amount {
      margin-top: 20px;
      padding: 5px 0;
      width: 100%;
      span {
        width: 20%;
        text-align: center;
        font-size: 20pt;
      }
    }
    .selected {
      background-color: $gray-dark;
      padding: 15px;
      text-align: center;
      color: $white;
      font-weight: 900;
    }
    .extra-products {
      width: 100%;
      margin: 20px auto;
      .sub-title {
        text-transform: uppercase;
        color: $white;
        font-weight: bold;
        padding-left: 5%;
      }
      .product-holder::-webkit-scrollbar {
        /* This is the magic bit for WebKit */
        display: none;
      }
      .product-holder {
        padding-left: 5%;
        max-width: unset;
        overflow-x: auto;
        white-space: nowrap;
        display: block;
        scrollbar-width: none;
      }
      .product {
        width: 80vw;
        height: 65vh;
        max-width: 80vw;
        border-radius: 4px;
        background-color: $white;
        min-height: 90px;
        margin-bottom: 10px;
        margin-right: 5%;
        position: relative;
        display: inline-table;
        .image-container {
          width: 100%;
          height: 60vw;
          background-position: center;
          background-size: cover;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
        }
        .information {
          padding: 10px;
          .price {
            font-weight: bold;
            margin-top: 10px;
            font-size: 1.2em;
          }
          p {
            word-break: break-all;
            white-space:normal;
            margin: 0.7em 0px;
          }
        }
        .c-checkmark {
          position: absolute;
          top: 0px;
          left: 10px;
          .checkmark, .checkbox {
            border-radius: 50%;
          }
        }
      }
    }
  }
</style>
